import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, FC, ReactNode } from 'react';
import styles from './button.module.css';

export interface ButtonProps {
  text?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  icon?: IconDefinition;
  iconComponent?: ReactNode;
  color?: string;
  style?: CSSProperties;
  className?: string;
  href?: string;
}

export const Button: FC<ButtonProps> = ({
  text,
  icon,
  iconComponent,
  color,
  style,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className,
  href,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.location.href = href;
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
      className={`${styles.button} ${className || ''}`}
      data-testid="custom-button"
    >
      {text && (
        <div style={{ marginLeft: icon || iconComponent ? '8px' : '0' }}>
          {text}
        </div>
      )}
      {icon && <FontAwesomeIcon icon={icon as any} size="3x" color={color} />}

      {iconComponent}
    </button>
  );
};
